import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ElementDetailsModalComponent, ElementDetailsModel } from '../AppBaseComponents/element-details-modal/element-details-modal.component';
import { TargetCandidate } from '../Models/web-recorded-command-model';

@Injectable({ providedIn: 'root' })
export class ElementDetailsService {

  constructor(private dialog: MatDialog) {}

  open(candidates: TargetCandidate[]): void {
    this.dialog.open(ElementDetailsModalComponent, {
      data: new ElementDetailsModel(candidates || []),
      width: '900px',
      maxWidth: '90vw',
      // Give Material's own dialog container (.mat-dialog-container, which
      // wraps everything outside our component's own template/styles) an
      // explicit height budget — without it, our inner .details-body scroll
      // area could exceed Material's default container height, pushing its
      // own scrollbar past what the container actually renders.
      maxHeight: '85vh',
      panelClass: 'ze-element-details-dialog-panel'
    });
  }
}
